import { axios } from '@/network/util/request'
import { getExpiringDate } from '@/network/api/companyGroup'

const app = {
	state: {
		companyGroupFullName: '',
		companyGroupName: '',
		companyGroupLogoUrl: '',
		factoryLogoUrl: '',
		factoryHomeImageUrl: '',
		factoryLoginImageUrl: '',
		expiringDate: 0,
		version:"2021-3-2"
	},
	mutations: {
		/**
		 * 设置系统统一配置。
		 */
		setGlobalConfig: (state, data) => {
			console.log('setGlobalConfig', data)
			if (!data) return

			state.companyGroupFullName = data.companyGroupFullName
			state.companyGroupName = data.companyGroupName
			state.companyGroupLogoUrl = data.companyGroupLoginImageUrl
			state.factoryLogoUrl = data.factoryLogoUrl
			state.factoryHomeImageUrl = data.factoryHomeImageUrl
			state.factoryLoginImageUrl = data.factoryLoginImageUrl
		},
		/**
		 *设置到期时间。
		 */
		setExpiringDate: (state, data) => {
			state.expiringDate = data
		},
	},
	actions: {
		/**
		 * 获取系统统一配置。
		 * @param {*} factory
		 */
		getGlobalConfig({ commit }, { factory, companyDomain }) {
			var param = ''
			if (factory) {
				param = `factory=${factory}`
			} else {
				param = `companyDomain=${companyDomain}`
			}

			axios({
				url: `/companyGroup/publicInfo?${param}`,
				method: 'get',
			}).then(res => {
				commit('setGlobalConfig', res.result)
			})
		},
		/**
		 * 查询到期时间。
		 * @param {*} param0
		 * @param {*} companyDomain
		 */
		getExpiringDate({ commit }, companyDomain) {
			getExpiringDate(companyDomain).then(res => {
				commit('setExpiringDate', res.result)
			})
		},
	},
	getters: {
		/**
		 * 判断是否是公有云。
		 */
		isPublic() {
			var version = process.env.VUE_APP_VERSION
			return version == 'public'
		},
		homeImage(state) {
			if (state.isPublic) {
				return ''
			} else {
				return state.factoryHomeImageUrl
			}
		},
	},
}

export default app
